import { Injectable } from "@angular/core";
import { WebsocketRequest, WebsocketResponse, WebsocketService } from "@app/shared/databases/websocket";
import { Observable } from "rxjs";
import { TSLoggingService } from "../services/ts-logging.service";

/* eslint-disable @typescript-eslint/naming-convention */
interface PushServerRequestData {
    after_domain_params: string;
    http_method: string;
    raw_body_content: {
        data?: Record<string, unknown>;
    };
}

interface PushServerRequest extends WebsocketRequest {
    push_server_data: PushServerRequestData;
}

interface PushServerResponse extends WebsocketResponse {
    push_server_data: PushServerRequestData;
}
/* eslint-enable @typescript-eslint/naming-convention */

@Injectable({
    providedIn: "root",
})
export class PushServerDatabaseService {
    requestType = "push_server";

    constructor(private websocket: WebsocketService, private readonly tsLoggingService: TSLoggingService) {}

    private preparePushServerRequest(path: string, method = "DELETE", body = {}): PushServerRequestData {
        /* eslint-disable @typescript-eslint/naming-convention */
        return {
            after_domain_params: `/${path}`,
            http_method: method,
            raw_body_content: body,
        };
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    private makeRequest(data: PushServerRequestData): Observable<PushServerResponse> {
        /* eslint-disable @typescript-eslint/naming-convention */
        return this.websocket.makeRequest({
            request_type: this.requestType,
            session_id: "",
            push_server_data: data,
            headers: null,
            metadata: {},
        });
        /* eslint-enable @typescript-eslint/naming-convention */
    }

    public unregisterUser$(firebaseId: string, uuid: string): Observable<any> {
        const data = this.preparePushServerRequest(`clientRecord?firebaseId=${firebaseId}&serverUUID=${uuid}`, "DELETE");
        this.tsLoggingService.logEvent(uuid, "remove_location", "firebase", "unregister", firebaseId, data);
        return this.makeRequest(data);
    }

    /**
     * unsubscribe all users from firebase server
     *
     * @param uuid
     * @returns
     */
    public unregisterUsers$(uuid: string): Observable<any> {
        const data = this.preparePushServerRequest(`clientRecord?serverUUID=${uuid}`, "DELETE");
        return this.makeRequest(data);
    }
}
